module.exports = __webpack_public_path__ + "static/front-011-f7552e5848a47df7ff350f4e9b61ee6f.png";